const CONTENT_PLACEHOLDER = "{{EMAIL_CONTENT}}";

// Mirrors src/gs.be/mailTemplates/defaultDesign.html + helpers/emailDesign.js
// on the backend, which is what actually gets sent. This copy exists only to
// render the live preview in the EmailTemplates editor — keep both in sync.
const DEFAULT_EMAIL_DESIGN = `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Akreditacije</title>
</head>
<body style="margin:0; padding:0; background-color:#f4f6f9; font-family: Arial, Helvetica, sans-serif;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f6f9; padding:32px 0;">
    <tr>
      <td align="center">
        <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff; border-radius:8px; overflow:hidden; max-width:600px; width:100%;">

          <!-- thin brand bar -->
          <tr>
            <td style="height:4px; background-color:#0d4077; font-size:0; line-height:0;">&nbsp;</td>
          </tr>

          <!-- CONTENT -->
          <tr>
            <td style="padding:36px 40px 8px 40px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:1.65; color:#1a1a1a;">
${CONTENT_PLACEHOLDER}
            </td>
          </tr>

          <!-- FOOTER SIGNATURE -->
          <tr>
            <td style="padding:8px 40px 36px 40px;">
              <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-top:1px solid #e5e9f0;">
                <tr><td style="height:24px; font-size:0; line-height:0;">&nbsp;</td></tr>
              </table>
              <table role="presentation" cellpadding="0" cellspacing="0">
                <tr>
                  <td style="width:48px; padding-right:16px; vertical-align:middle;">
                    <img src="https://www.gs.gov.rs/img/logo_60x120-2.png" width="40" height="80" alt="Grb Republike Srbije" style="display:block; width:40px; height:80px; max-width:40px;">
                  </td>
                  <td style="width:2px; background-color:#0d4077; font-size:0; line-height:0;">&nbsp;</td>
                  <td style="padding-left:16px; vertical-align:middle; font-family:Arial, Helvetica, sans-serif;">
                    <a href="https://akreditacije.gov.rs" style="color:#1a1a1a; text-decoration:none; font-size:13px; font-weight:700; line-height:1.4;">
                      Akreditacije Generalnog sekretarijata<br>Vlade Republike Srbije
                    </a>
                    <br>
                    <a href="https://akreditacije.gov.rs" style="color:#0d4077; text-decoration:none; font-size:12px; font-weight:400;">
                      akreditacije.gov.rs
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;

const escapeHtml = (str = "") =>
  str
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");

const URL_PATTERN = /(https?:\/\/[^\s<>"]+)/g;

// Mirrors gs.be's linkifyAndEscape: a bare URL in the text (e.g. a
// password-reset link) should preview as a real clickable link, not inert
// escaped text.
const linkifyAndEscape = (text) =>
  text
    .split(URL_PATTERN)
    .map((part, i) =>
      i % 2 === 1
        ? `<a href="${escapeHtml(part)}" style="color:#0d4077;">${escapeHtml(part)}</a>`
        : escapeHtml(part),
    )
    .join("");

const SEPARATOR_LINE = /^-{3,}$/;

// Mirrors gs.be's textToContentHtml: blank-line-separated paragraphs, single
// line breaks preserved as <br/>. A standalone "---" line renders as a real
// divider. ${...} metadata placeholders are left as-is since they're only
// rendered at send time.
export const textToContentHtml = (text = "") =>
  text
    .split(/\r?\n\s*\r?\n/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) =>
      SEPARATOR_LINE.test(block)
        ? '<hr style="border:none; border-top:1px solid #e5e9f0; margin:8px 0 24px 0;" />'
        : `<p style="margin:0 0 16px 0;">${linkifyAndEscape(block).replace(/\r?\n/g, "<br/>")}</p>`,
    )
    .join("\n");

export const buildEmailPreviewHtml = (textBody = "") =>
  DEFAULT_EMAIL_DESIGN.replace(
    CONTENT_PLACEHOLDER,
    textBody.trim()
      ? textToContentHtml(textBody)
      : '<p style="margin:0; color:#9a9a9a;">&nbsp;</p>',
  );
